/**
 * 通用 Add to Cart 功能
 * 
 * 配置选项（通过 window.mtAddToCartConfig 设置）：
 * - buttonClass: 按钮的类名，默认 'mt-add-to-cart'
 * - variantIdAttr: 变体ID的data属性名，默认 'data-variant-id'
 * - quantityAttr: 数量的data属性名，默认 'data-quantity'（可选，默认值为1）
 * - disabledClass: 禁用状态的类名，默认 'mt-add-to-cart--sold-out'
 * 
 * 使用示例：
 * <button class="mt-add-to-cart" data-variant-id="123456" data-quantity="1">Add to Cart</button>
 */
(function() {
  // 默认配置
  const defaultConfig = {
      buttonClass: 'mt-add-to-cart',
      variantIdAttr: 'data-variant-id',
      quantityAttr: 'data-quantity',
      disabledClass: 'mt-add-to-cart--sold-out'
  };

  // 合并用户配置
  const config = Object.assign({}, defaultConfig, window.mtAddToCartConfig || {});

  // 辅助函数：控制加载状态（支持多种按钮结构）
  function setLoadingState(button, isLoading) {
      if (!button) return;
      
      // 支持 mt-swiper2 的图标按钮
      const swiperLoadingElement = button.querySelector('.mt-swiper-add-to-cart__loading');
      const swiperIconElement = button.querySelector('.mt-swiper-add-to-cart__icon');
      
      // 支持 mt-product-list7 的文本按钮
      const listLoadingElement = button.querySelector('.mt-review-slider__btn-loading');
      const listTextElement = button.querySelector('.mt-review-slider__btn-text');
      
      if (isLoading) {
          button.classList.add('mt-add-to-cart--loading');
          button.disabled = true;
          
          // 处理 mt-swiper2 按钮
          if (swiperLoadingElement) {
              swiperLoadingElement.classList.remove('hidden');
          }
          if (swiperIconElement) {
              swiperIconElement.style.opacity = '0';
          }
          
          // 处理 mt-product-list7 按钮
          if (listLoadingElement) {
              listLoadingElement.classList.remove('hidden');
          }
          if (listTextElement) {
              listTextElement.style.opacity = '0';
          }
      } else {
          button.classList.remove('mt-add-to-cart--loading');
          button.disabled = false;
          
          // 处理 mt-swiper2 按钮
          if (swiperLoadingElement) {
              swiperLoadingElement.classList.add('hidden');
          }
          if (swiperIconElement) {
              swiperIconElement.style.opacity = '1';
          }
          
          // 处理 mt-product-list7 按钮
          if (listLoadingElement) {
              listLoadingElement.classList.add('hidden');
          }
          if (listTextElement) {
              listTextElement.style.opacity = '1';
          }
      }
  }

  // 全局点击事件处理 - 处理 Add to cart 按钮
  document.addEventListener('click', function(e) {
      // 检查是否点击了 Add to cart 按钮
      const addToCartBtn = e.target.closest('.' + config.buttonClass);
      if (addToCartBtn) {
          // 检查按钮是否被禁用（Sold out）
          if (addToCartBtn.disabled || addToCartBtn.classList.contains(config.disabledClass)) {
              e.preventDefault();
              e.stopPropagation();
              return;
          }
          
          e.preventDefault();
          e.stopPropagation();
          
          // 显示加载状态
          setLoadingState(addToCartBtn, true);
          
          // 获取变体ID
          const variantId = addToCartBtn.getAttribute(config.variantIdAttr);
          
          if (!variantId) {
              console.error('Variant ID not found. Please set ' + config.variantIdAttr + ' attribute.');
              return;
          }
          
          // 验证变体ID是否为有效数字
          const parsedVariantId = parseInt(variantId, 10);
          if (isNaN(parsedVariantId) || parsedVariantId <= 0) {
              console.error('Invalid variant ID:', variantId);
              return;
          }
          
          // 获取数量（可选，默认为1）
          const quantityAttr = addToCartBtn.getAttribute(config.quantityAttr);
          const quantity = quantityAttr ? parseInt(quantityAttr, 10) : 1;
          
          // 验证数量是否有效
          if (isNaN(quantity) || quantity <= 0) {
              console.error('Invalid quantity:', quantity);
              return;
          }
          
          // 如果存在全局加车函数，使用它
          if (typeof window.mtAddToCart === 'function') {
              window.mtAddToCart({
                  variantId: parsedVariantId,
                  quantity: quantity,
                  button: addToCartBtn // 传递按钮引用以便控制加载状态
              });
          } else {
              // 如果没有全局函数，直接调用 Shopify API
              // 使用 FormData 格式（与主题其他部分保持一致）
              const formData = new FormData();
              formData.append('id', parsedVariantId);
              formData.append('quantity', quantity);

              const cartDrawer = document.querySelector('cart-drawer');
              const cartNotification = document.querySelector('cart-notification');
    
              let fetchConfig = {
                  method: 'POST',
                  headers: {
                      'X-Requested-With': 'XMLHttpRequest'
                      // 不设置 Content-Type，让浏览器自动设置（FormData 需要 multipart/form-data）
                  },
                  body: formData
              };
    
              // 如果需要更新 sections，添加到 FormData
              if (cartNotification) {
                  const sections = ['cart-notification-product', 'cart-notification-button', 'cart-icon-bubble'];
                  formData.append('sections', sections.join(','));
                  formData.append('sections_url', window.location.pathname);
              } else if (cartDrawer) {
                  formData.append('sections', ['cart-icon-bubble', 'cart-drawer'].join(','));
                  formData.append('sections_url', window.location.pathname);
              }
    
              // 调试：记录发送的数据
              console.log('Adding to cart:', { id: parsedVariantId, quantity: quantity });
              
              fetch('/cart/add.js', fetchConfig)
                  .then(function(response) {
                      // 检查响应状态
                      if (!response.ok) {
                          // 尝试读取错误信息
                          return response.text().then(function(text) {
                              const errorMsg = text || 'Empty response';
                              console.error('Cart API Error:', {
                                  status: response.status,
                                  statusText: response.statusText,
                                  body: errorMsg,
                                  requestData: { id: parsedVariantId, quantity: quantity }
                              });
                              
                              try {
                                  const errorData = JSON.parse(text);
                                  throw new Error(errorData.description || errorData.message || 'Failed to add item to cart (Status: ' + response.status + ')');
                              } catch (e) {
                                  if (e instanceof Error && e.message.indexOf('Failed to add item to cart') === -1) {
                                      throw new Error('Failed to add item to cart (Status: ' + response.status + '): ' + errorMsg);
                                  }
                                  throw e;
                              }
                          });
                      }
                      return response.json();
                  })
                  .then(function(data) {
                      // 隐藏加载状态
                      setLoadingState(addToCartBtn, false);
                      
                      if (data.status) {
                          console.error('Error adding to cart:', data);
                          return;
                      }
    
                      // 更新 cart-icon-bubble
                      if (data.sections && data.sections['cart-icon-bubble']) {
                          const cartIconBubble = document.querySelector('#cart-icon-bubble');
                          if (cartIconBubble) {
                              const parser = new DOMParser();
                              const doc = parser.parseFromString(data.sections['cart-icon-bubble'], 'text/html');
                              const newCartIconBubble = doc.querySelector('#cart-icon-bubble');
                              if (newCartIconBubble) {
                                  cartIconBubble.outerHTML = newCartIconBubble.outerHTML;
                              }
                          }
                      }
    
                      // 更新 cart-drawer
                      if (data.sections && data.sections['cart-drawer']) {
                          const cartDrawerElement = document.querySelector('cart-drawer');
                          if (cartDrawerElement) {
                              const parser2 = new DOMParser();
                              const doc2 = parser2.parseFromString(data.sections['cart-drawer'], 'text/html');
                              const newCartDrawer = doc2.querySelector('cart-drawer');
                              if (newCartDrawer) {
                                  cartDrawerElement.outerHTML = newCartDrawer.outerHTML;
                              }
                          }
                      }
    
                      setTimeout(function() {
                          const updatedCartNotification = document.querySelector('cart-notification');
                          const updatedCartDrawer = document.querySelector('cart-drawer');
                          if (updatedCartNotification && typeof updatedCartNotification.open === 'function') {
                              updatedCartNotification.open();
                          } else if (updatedCartDrawer && typeof updatedCartDrawer.open === 'function') {
                              updatedCartDrawer.open();
                          } else if (window.CartDrawer && typeof window.CartDrawer.open === 'function') {
                              window.CartDrawer.open();
                          } else if (typeof window.openCartDrawer === 'function') {
                              window.openCartDrawer();
                          }
                      }, 300);
                  })
                  .catch(function(error) {
                      // 隐藏加载状态
                      setLoadingState(addToCartBtn, false);
                      console.error('Error:', error);
                  });
          }
      }
  });
})();

// 如果主题中还没有通用加车函数，这里提供一个简化版本
if (typeof window.mtAddToCart !== 'function') {
  window.mtAddToCart = function(options) {
    const variantId = options && options.variantId;
    const quantity = options && options.quantity ? options.quantity : 1;
    const button = options && options.button;
    
    // 验证参数
    if (!variantId) {
      console.error('Variant ID is required');
      return;
    }
    
    const parsedVariantId = parseInt(variantId, 10);
    if (isNaN(parsedVariantId) || parsedVariantId <= 0) {
      console.error('Invalid variant ID:', variantId);
      return;
    }
    
    const parsedQuantity = parseInt(quantity, 10);
    if (isNaN(parsedQuantity) || parsedQuantity <= 0) {
      console.error('Invalid quantity:', quantity);
      return;
    }
    
    // 控制加载状态（如果提供了按钮，支持多种按钮结构）
    function setLoadingState(btn, isLoading) {
      if (!btn) return;
      
      // 支持 mt-swiper2 的图标按钮
      const swiperLoadingElement = btn.querySelector('.mt-swiper-add-to-cart__loading');
      const swiperIconElement = btn.querySelector('.mt-swiper-add-to-cart__icon');
      
      // 支持 mt-product-list7 的文本按钮
      const listLoadingElement = btn.querySelector('.mt-review-slider__btn-loading');
      const listTextElement = btn.querySelector('.mt-review-slider__btn-text');
      
      if (isLoading) {
        btn.classList.add('mt-add-to-cart--loading');
        btn.disabled = true;
        
        // 处理 mt-swiper2 按钮
        if (swiperLoadingElement) {
          swiperLoadingElement.classList.remove('hidden');
        }
        if (swiperIconElement) {
          swiperIconElement.style.opacity = '0';
        }
        
        // 处理 mt-product-list7 按钮
        if (listLoadingElement) {
          listLoadingElement.classList.remove('hidden');
        }
        if (listTextElement) {
          listTextElement.style.opacity = '0';
        }
      } else {
        btn.classList.remove('mt-add-to-cart--loading');
        btn.disabled = false;
        
        // 处理 mt-swiper2 按钮
        if (swiperLoadingElement) {
          swiperLoadingElement.classList.add('hidden');
        }
        if (swiperIconElement) {
          swiperIconElement.style.opacity = '1';
        }
        
        // 处理 mt-product-list7 按钮
        if (listLoadingElement) {
          listLoadingElement.classList.add('hidden');
        }
        if (listTextElement) {
          listTextElement.style.opacity = '1';
        }
      }
    }
    
    // 显示加载状态
    setLoadingState(button, true);

    // 使用 FormData 格式（与主题其他部分保持一致）
    const formData = new FormData();
    formData.append('id', parsedVariantId);
    formData.append('quantity', parsedQuantity);

    const cartDrawer = document.querySelector('cart-drawer');
    const cartNotification = document.querySelector('cart-notification');

    let config = {
      method: 'POST',
      headers: {
        'X-Requested-With': 'XMLHttpRequest'
        // 不设置 Content-Type，让浏览器自动设置（FormData 需要 multipart/form-data）
      },
      body: formData
    };

    // 如果需要更新 sections，添加到 FormData
    if (cartNotification) {
      const sections = ['cart-notification-product', 'cart-notification-button', 'cart-icon-bubble'];
      formData.append('sections', sections.join(','));
      formData.append('sections_url', window.location.pathname);
    } else if (cartDrawer) {
      formData.append('sections', ['cart-icon-bubble', 'cart-drawer'].join(','));
      formData.append('sections_url', window.location.pathname);
    }

    // 调试：记录发送的数据
    console.log('Adding to cart:', { id: parsedVariantId, quantity: parsedQuantity });
    
    fetch('/cart/add.js', config)
      .then(function(response) {
        // 检查响应状态
        if (!response.ok) {
          // 尝试读取错误信息
          return response.text().then(function(text) {
            const errorMsg = text || 'Empty response';
            console.error('Cart API Error:', {
              status: response.status,
              statusText: response.statusText,
              body: errorMsg,
              requestData: { id: parsedVariantId, quantity: parsedQuantity }
            });
            
            try {
              const errorData = JSON.parse(text);
              throw new Error(errorData.description || errorData.message || 'Failed to add item to cart (Status: ' + response.status + ')');
            } catch (e) {
              if (e instanceof Error && e.message.indexOf('Failed to add item to cart') === -1) {
                throw new Error('Failed to add item to cart (Status: ' + response.status + '): ' + errorMsg);
              }
              throw e;
            }
          });
        }
        return response.json();
      })
      .then(function(data) {
        // 隐藏加载状态
        setLoadingState(button, false);
        
        if (data.status) {
          console.error('Error adding to cart:', data);
          return;
        }

        // 更新 cart-icon-bubble
        if (data.sections && data.sections['cart-icon-bubble']) {
          const cartIconBubble = document.querySelector('#cart-icon-bubble');
          if (cartIconBubble) {
            const parser = new DOMParser();
            const doc = parser.parseFromString(data.sections['cart-icon-bubble'], 'text/html');
            const newCartIconBubble = doc.querySelector('#cart-icon-bubble');
            if (newCartIconBubble) {
              cartIconBubble.outerHTML = newCartIconBubble.outerHTML;
            }
          }
        }

        // 更新 cart-drawer
        if (data.sections && data.sections['cart-drawer']) {
          const cartDrawerElement = document.querySelector('cart-drawer');
          if (cartDrawerElement) {
            const parser2 = new DOMParser();
            const doc2 = parser2.parseFromString(data.sections['cart-drawer'], 'text/html');
            const newCartDrawer = doc2.querySelector('cart-drawer');
            if (newCartDrawer) {
              cartDrawerElement.outerHTML = newCartDrawer.outerHTML;
            }
          }
        }

        setTimeout(function() {
          const updatedCartNotification = document.querySelector('cart-notification');
          const updatedCartDrawer = document.querySelector('cart-drawer');
          if (updatedCartNotification && typeof updatedCartNotification.open === 'function') {
            updatedCartNotification.open();
          } else if (updatedCartDrawer && typeof updatedCartDrawer.open === 'function') {
            updatedCartDrawer.open();
          } else if (window.CartDrawer && typeof window.CartDrawer.open === 'function') {
            window.CartDrawer.open();
          } else if (typeof window.openCartDrawer === 'function') {
            window.openCartDrawer();
          }
        }, 300);
      })
      .catch(function(error) {
        // 隐藏加载状态
        setLoadingState(button, false);
        console.error('Error:', error);
      });
  };
}

